import Image from 'next/image';
import { useIntl } from 'react-intl';
import styles from './OrganizerBannerBackground.module.scss';

export interface OrganizerBannerBackgroundProps {
  coverUrl?: string;
  avatarUrl?: string;
  className: string;
  imageTestId?: string;
}

export function OrganizerBannerBackground({
  coverUrl,
  avatarUrl,
  className,
  imageTestId,
}: OrganizerBannerBackgroundProps) {
  const intl = useIntl();
  const coverTrimmed = coverUrl?.trim() ?? '';
  const avatarTrimmed = avatarUrl?.trim() ?? '';
  const hasCover = coverTrimmed.length > 0;
  const useAvatarAsBackground = !hasCover && avatarTrimmed.length > 0;
  const rootClass = [styles.root, className].join(' ');

  return (
    <div className={rootClass}>
      {hasCover ? (
        <Image
          src={coverTrimmed}
          alt={intl.formatMessage({ id: 'Cover', defaultMessage: 'Cover' })}
          className={styles.coverImage}
          data-testid={imageTestId}
          fill
        />
      ) : useAvatarAsBackground ? (
        <Image
          src={avatarTrimmed}
          alt=""
          aria-hidden="true"
          className={styles.avatarBlur}
          data-testid={imageTestId}
          width={1200}
          height={1200}
        />
      ) : null}
    </div>
  );
}
